import { useEffect } from 'react';
import clsx from 'clsx';

import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import { Icon } from '@atom/mui';
import { LayersIcon, ViewListIcon } from '@atom/mui/icons';

import classes from './mapPortal.module.css';

const SideNav = () => {
  const [{ view }, { updateSearchParams }] = useNavigation({
    view: SearchParamType.STRING,
  });

  useEffect(() => {
    if (!view) {
      updateSearchParams({ view: 'layers' });
    }
  }, [view, updateSearchParams]);

  const activeView = view || 'layers';

  return (
    <div className={classes.sideNav}>
      <div
        className={clsx(
          classes.navLink,
          activeView === 'layers' && classes.navLinkActive,
        )}
        onClick={() => updateSearchParams({ view: 'layers' })}
      >
        <Icon icon={LayersIcon} />
      </div>
      <div
        className={clsx(
          classes.navLink,
          activeView === 'list' && classes.navLinkActive,
        )}
        onClick={() => updateSearchParams({ view: 'list' })}
      >
        <Icon icon={ViewListIcon} />
      </div>
    </div>
  );
};

export default SideNav;
